module.exports = __webpack_public_path__ + "static/media/streaming.f1a74884.svg";